export default function AboutSection() {
  return (
    <section id="about" className="py-12 md:py-16 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[900px] mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-2">
            关于我们
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            了解91电影视频的故事与使命
          </p>
        </div>

        <div className="p-6 md:p-8 rounded-lg bg-background-50 border border-background-200/70">
          <div className="max-w-2xl mx-auto text-center">
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
              91电影视频成立于2021年，是一家专注于国产精品影视内容的在线观看平台。
              我们致力于汇聚最优质的国产电影、电视剧和自制剧资源，
              为全国影视爱好者提供高清、免费、无广告的观影体验。
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
              平台片库涵盖动作大片、悬疑烧脑、温情剧情、古装巨制、科幻想象等全类型内容，
              每日更新50部以上精选影片。无论你是热衷于院线新片的影迷，
              还是喜欢回味经典老片的观众，都能在这里找到属于自己的影视天地。
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
              91电影视频始终秉持「好内容，免费看」的理念，
              持续优化播放技术和内容质量，努力成为国产影视爱好者最信赖的在线观影平台。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}